import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";
import { getInfluencerRef } from "../utils/influencerAttribution";

type EnsureInfluencerSignupBonusResponse = {
  success: boolean;
  granted: boolean;
  alreadyGranted: boolean;
  hours: number | null;
  attributed: boolean;
};

/**
 * Libera 2 horas só se a conta foi criada com o link (idempotente).
 * Conta antiga, mesmo com o link salvo no navegador, não ganha.
 */
export async function ensureInfluencerSignupBonus(): Promise<EnsureInfluencerSignupBonusResponse | null> {
  const influencerCode = getInfluencerRef();
  const callable = httpsCallable<{ influencerCode: string | null }, EnsureInfluencerSignupBonusResponse>(
    functions,
    "ensureInfluencerSignupBonus"
  );
  const result = await callable({ influencerCode });
  return result.data;
}
